(function () {
	function swiperInit() {
		subSliderInit(true)
		sliderInit(true)
	}

	document.addEventListener('shopify:section:load', function () {
		swiperInit()
	})

	swiperInit()

	window.addEventListener('load', function () {
		document
			.querySelectorAll('.product-section .js-media-list, .product-section .js-media-sublist')
			.forEach((el) => {
				if (el.swiper) {
					el.swiper.update()
				}
			})
	})
})()
